module.exports = __webpack_public_path__ + "static/media/user_icon.a5d15d94.svg";